export default function MultiSelectChips({
  label,
  items = [],
  value = [],
  onToggle,
  loading = false,
  required,
  error,
  disabled = false, // ✅ add this
}) {
  return (
    <div className="flex flex-col">
      <label className="text-sm font-medium text-slate-700 mb-1">
        {label}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>

      {loading ? (
        <p className="text-xs text-slate-500">Loading...</p>
      ) : (
        <div className="flex flex-wrap gap-2">
          {items.map((item) => {
            const active = value.includes(item.value);

            return (
              <button
                key={item.value}
                type="button"

                // ✅ SAFETY GUARD
                onClick={() => {
                  if (disabled) return;
                  if (typeof onToggle !== "function") return;
                  onToggle(item.value);
                }}

                disabled={disabled}
                className={`px-3 py-1 rounded-full text-xs border transition
                  ${
                    active
                      ? "bg-primary text-white border-primary"
                      : "bg-slate-50 text-slate-700 border-slate-300 hover:bg-slate-100"
                  }
                  ${disabled ? "opacity-60 cursor-not-allowed" : ""}
                `}
              >
                {item.label}
              </button>
            );
          })}
        </div>
      )}

      {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
}

